// Telegram bot start / Mini App startapp payloads.
// Referral codes stay bare. Deep links use a typed prefix so register vs
// destination routing can tell them apart.

const PENDING_KEY = 'pending_deep_link'

export type ParsedStartParam =
  | { kind: 'dream'; matchId: number; teamId: number }
  | { kind: 'fantasy'; token: string }
  | { kind: 'referral'; code: string }
  | { kind: 'none' }

export function buildDreamTeamStartPayload(matchId: number, teamId: number): string {
  return `dream_${matchId}_${teamId}`
}

/** Production bot for dream-team deep links (override via API bot_username). */
export const DEFAULT_TELEGRAM_BOT_USERNAME = 'iliya_aaa_bot'

function normalizeBotUsername(botUsername?: string | null): string {
  return (botUsername || DEFAULT_TELEGRAM_BOT_USERNAME).replace(/^@/, '').trim() || DEFAULT_TELEGRAM_BOT_USERNAME
}

export function buildDreamTeamBotLink(botUsername: string, matchId: number, teamId: number): string {
  const user = normalizeBotUsername(botUsername)
  const payload = buildDreamTeamStartPayload(matchId, teamId)
  return `https://t.me/${user}?start=${encodeURIComponent(payload)}`
}

/** Invite deep link: opens the bot with the user's referral code as start payload. */
export function buildReferralInviteLink(botUsername: string, referralCode: string): string {
  const user = normalizeBotUsername(botUsername)
  const code = (referralCode || '').trim()
  if (!code) return `https://t.me/${user}`
  return `https://t.me/${user}?start=${encodeURIComponent(code)}`
}

export function parseStartParam(raw: string | null | undefined): ParsedStartParam {
  const s = (raw || '').trim()
  if (!s) return { kind: 'none' }

  const lower = s.toLowerCase()
  if (lower.startsWith('dream_')) {
    const parts = s.slice('dream_'.length).split('_')
    if (parts.length >= 2) {
      const matchId = Number(parts[0])
      const teamId = Number(parts[1])
      if (matchId > 0 && teamId > 0) {
        return { kind: 'dream', matchId, teamId }
      }
    }
    return { kind: 'none' }
  }

  if (lower.startsWith('fantasy_')) {
    const token = s.slice('fantasy_'.length).trim()
    if (token) return { kind: 'fantasy', token }
    return { kind: 'none' }
  }

  return { kind: 'referral', code: s }
}

export function pathForStartParam(raw: string | null | undefined): string | null {
  const parsed = parseStartParam(raw)
  if (parsed.kind === 'dream') {
    return `/football/dream-teams/${parsed.teamId}`
  }
  if (parsed.kind === 'fantasy') {
    return `/fantasy/vote?token=${encodeURIComponent(parsed.token)}`
  }
  return null
}

export function isDeepLinkStartParam(raw: string | null | undefined): boolean {
  const kind = parseStartParam(raw).kind
  return kind === 'dream' || kind === 'fantasy'
}

export function rememberDeepLink(raw: string | null | undefined) {
  const path = pathForStartParam(raw)
  if (path) {
    try {
      sessionStorage.setItem(PENDING_KEY, path)
    } catch {
      // ignore quota / private mode
    }
  }
}

export function consumePendingDeepLink(fallbackRaw?: string | null): string | null {
  try {
    const stored = sessionStorage.getItem(PENDING_KEY)
    if (stored) {
      sessionStorage.removeItem(PENDING_KEY)
      return stored
    }
  } catch {
    // ignore
  }
  return pathForStartParam(fallbackRaw)
}
